/* eslint-disable global-require,import/no-unresolved */
import React from 'react'
import { ScrollView, View } from 'react-native'
import { colors } from '../../styles'
import IndicatorLightsOptions from './IndicatorLightsOptions'

export default function LightStatePage() {
  return (
    <View style={{ flex: 1 }}>
      <View style={{ flex: 1, backgroundColor: colors.raven_grey10 }}>
        <ScrollView
          testID="scrollview-Lights"
        >
          <IndicatorLightsOptions
            headerText="indicatorLights:learnTheLights"
            headerTextID="learn-the-lights"
            testID="IndicatorLightsOptionsComponent"
          />
        </ScrollView>
      </View>
    </View>
  )
}
